import state from "./state";
import mutations from "./mutations";
import actions from "./actions";

// import createVuexAlong from "vuex-along";

import Vue from "vue";
import Vuex from "vuex";
import base from "./modules/base";
import flow from "./modules/flow";

Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    base,
    flow
  },
  state,
  mutations,
  actions,

});



// WEBPACK FOOTER //
// ./src/store/index.js